import React from 'react'
import Start from './Start'
import Latest from './Latest'
import Bestsellers from './Bestsellers'
import Policy from './Policy'
import Box from './Box'
const Home = () => {
  return (
    <div>
<Start/>
<Latest/>
<Bestsellers/>
<Policy/>
<Box/>
    </div>
  )
}

export default Home